export const ru = {
    'action-delete': 'Удалить',
    'action-delete-thread': 'Удалить обсуждение',
    'action-discussion': 'Начать обсуждение',
    'action-edit': 'Редактировать',
    'action-expand-thread-comments': [ 'Еще {{count}} сообщение', 'Еще {{count}} сообщения', 'Еще {{count}} сообщений', 'Еще {{count}} сообщений' ],
    'action-reply': 'Ответить',
    'error-add-title': 'Не удалось добавить комментарий',
    'error-delete-title': 'Не удалось удалить комментарий',
    'error-edit-title': 'Не удалось сохранить комментарий',
    'error-empty-text': 'На этой странице пока нет комментариев.',
    'error-empty-title': 'Здесь ничего нет',
    'error-get-title': 'Не удалось загрузить комментарии',
    placeholder: 'Добавить комментарий',
    'placeholder-thread': 'Добавить ответ',
    title: 'Комментарии'
};
